import React, { useState, useEffect } from 'react';
import './Products.css';
import { Link } from 'react-router-dom';
import { FaSearch, FaRedo } from 'react-icons/fa'; // FaRedo ekledik
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';

const Products = () => {
  const [products, setProducts] = useState([]); 
  const [categories, setCategories] = useState([]); 
  const [heroImages, setHeroImages] = useState([]); 
  const [currentHeroIdx, setCurrentHeroIdx] = useState(0); 
  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);

    const qProd = query(collection(db, "products"), orderBy("createdAt", "desc"));
    const unsubProd = onSnapshot(qProd, (snapshot) => {
      const allData = snapshot.docs.map(doc => ({ 
        docId: doc.id, 
        ...doc.data() 
      }));
      setProducts(allData);
      const images = allData.slice(0, 5).map(p => p.img).filter(img => img !== undefined);
      setHeroImages(images);
      setCurrentHeroIdx(prev => (prev >= images.length ? 0 : prev));
      setLoading(false);
    }, (err) => {
      console.error("Ürün dinleme hatası:", err);
      setLoading(false);
    });

    const unsubCats = onSnapshot(collection(db, "categories"), (snapshot) => {
      const cats = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setCategories(cats);
    });

    return () => {
      unsubProd();
      unsubCats();
    };
  }, []);

  useEffect(() => {
    if (heroImages.length > 1) {
      const interval = setInterval(() => {
        setCurrentHeroIdx((prev) => (prev + 1) % heroImages.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [heroImages.length]);

  const filteredProducts = products.filter(p => {
    const matchesFilter = filter === 'all' || p.cat === filter;
    const matchesSearch = 
      p.name?.toLowerCase().includes(searchTerm.toLowerCase()) || 
      p.id?.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  // Filtreleri sıfırlama fonksiyonu
  const resetFilters = () => {
    setFilter('all');
    setSearchTerm('');
  };

  return (
    <div className="products-page">
      <Navbar />
      
      <div className="products-hero">
        {heroImages.length > 0 ? (
          heroImages.map((img, index) => (
            <div 
              key={index}
              className={`hero-slide ${index === currentHeroIdx ? 'active' : ''}`}
              style={{ backgroundImage: `url(${img})` }}
            />
          ))
        ) : (
          <div className="hero-slide active" style={{ backgroundColor: '#0a0a0a' }} />
        )}
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <span className="gold-subtitle">Hazineyi Keşfet</span>
          <h1 className="main-title">Tüm <em>Koleksiyon</em></h1>
          <div className="title-line"></div>
        </div>
      </div>

      <div className="products-container">
        <div className="filter-bar">
          <div className="filter-group">
            <button className={filter === 'all' ? 'active' : ''} onClick={() => setFilter('all')}>
              Tümü
            </button>
            {categories.map((cat) => (
              <button 
                key={cat.id}
                className={filter === cat.slug ? 'active' : ''} 
                onClick={() => setFilter(cat.slug)}
              >
                {cat.title}
              </button>
            ))}
          </div>
          
          <div className="search-box">
            <input 
              type="text" 
              placeholder="Ürün veya Kod Ara..." 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <FaSearch className="search-icon" />
          </div>
        </div>

        {/* ÜRÜNLER ALANI */}
        <div className="products-grid-wrapper">
          {loading ? (
            <div className="loader-inline">Hazine Hazırlanıyor...</div>
          ) : filteredProducts.length > 0 ? (
            <div className="products-grid">
              {filteredProducts.map((product) => (
                <Link to={`/urun/${product.id}`} key={product.docId} className={`product-card-premium ${product.size || 'small'}`}>
                  <div className="card-image-wrapper">
                    <img src={product.img} alt={product.name} />
                    <div className="card-badge">#{product.id}</div>
                    <div className="card-overlay">
                      <span className="view-text">DETAYI GÖR</span>
                    </div>
                  </div>
                  <div className="card-info-premium">
                    <h3>{product.name}</h3>
                    <div className="card-footer">
                      <span className="price">{product.price}</span>
                      <div className="line"></div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            /* ARANAN ÜRÜN BULUNAMADIĞINDA ÇIKAN ŞIK ALAN */
            <div className="no-results-premium">
              <div className="empty-icon">
                <div className="icon-circle"></div>
                <span>?</span>
              </div>
              <h2>Aradığınız Eser Bulunamadı</h2>
              <p>
                Kriterlerinize uygun bir parça bulunamadı. <br />
                Farklı bir kelime deneyebilir veya filtreleri sıfırlayabilirsiniz.
              </p>
              <button onClick={resetFilters} className="explore-other-btn">
                Filtreleri Sıfırla <FaRedo style={{marginLeft: '10px', fontSize: '0.7rem'}} />
              </button>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Products;